import { Routes } from '@angular/router';
import { BankListComponent } from './bank-list/bank-list.component';
import { SuppliersListComponent } from './suppliers-list/suppliers-list.component';
import { StorageInvoicesListComponent } from './storage-invoices-list/storage-invoices-list.component';
import { SpendListComponent } from './spend/spend-list/spend-list.component';
import { SpendShowComponent } from '@manager-app/storage/spend/spend-show/spend-show.component';
import { SpendNewComponent } from '@manager-app/storage/spend/spend-new/spend-new.component';
import { SpendUpdateComponent } from '@manager-app/storage/spend/spend-update/spend-update.component';
import { StorageInvoicesReceiveComponent } from '@manager-app/storage/storage-invoices-receive/storage-invoices-receive.component';
import { ContractListComponent } from '@manager-app/storage/contract/list/contract-list.component';
import { StorageInvoiceEditComponent } from '@manager-app/storage/storage-invoice-edit/storage-invoice-edit.component';
import { StorageInvoiceViewComponent } from '@manager-app/storage/storage-invoice-view/storage-invoice-view.component';
import { ContractViewComponent } from '@manager-app/storage/contract/view/contract-view.component';
import { StoreProductsListComponent } from '@manager-app/storage/store-products-list/store-products-list.component';
import { PaymentApprovalListComponent } from '@manager-app/storage/payment-approval/list/payment-approval-list.component';
import { PaymentApprovalEditComponent } from '@manager-app/storage/payment-approval/edit/payment-approval-edit.component';

// site.kz/storage/
export const storageRouting: Routes = [
  {
    path: 'banks',
    component: BankListComponent
  },
  {
    path: 'products',
    component: StoreProductsListComponent
  },
  {
    path: 'suppliers',
    component: SuppliersListComponent
  },
  {
    path: 'contracts',
    component: ContractListComponent
  },
  {
    path: 'contracts/:id',
    component: ContractViewComponent,
    pathMatch: 'full'
  },
  {
    path: 'invoices',
    component: StorageInvoicesListComponent,
    pathMatch: 'full'
  },
  {
    path: 'invoices/new',
    component: StorageInvoiceEditComponent,
    pathMatch: 'full'
  },
  {
    path: 'invoices/:id/edit',
    component: StorageInvoiceEditComponent,
    pathMatch: 'full'
  },
  {
    path: 'invoices/:id',
    component: StorageInvoiceViewComponent,
    pathMatch: 'full'
  },
  {
    path: 'invoices/received/:id',
    component: StorageInvoicesReceiveComponent,
    pathMatch: 'full'
  },
  {
    path: 'spendings',
    component: SpendListComponent,
    pathMatch: 'full'
  },
  {
    path: 'spendings/show/:id',
    component: SpendShowComponent,
    pathMatch: 'full'
  },
  {
    path: 'spendings/new',
    component: SpendNewComponent,
    pathMatch: 'full'
  },
  {
    path: 'spendings/:id',
    component: SpendUpdateComponent,
    pathMatch: 'full'
  },
  {
    path: 'payment-approvals',
    component: PaymentApprovalListComponent,
    pathMatch: 'full'
  },
  {
    path: 'payment-approvals/new',
    component: PaymentApprovalEditComponent,
    pathMatch: 'full'
  },
];
